// src/Pages/ParqueGeneralView.jsx
import React, { useContext} from "react";
import RbdGenericList from "../Parque/RbdGenericList";
import PageBody from "../GeneralComponents/PageBody";
import GeneralContext from "../GeneralContext/GeneralContext";



import {ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";

export default function ParqueList() {
  const { includeRol } =  useContext(GeneralContext);

  return (
    <PageBody>
    <RbdGenericList
      pageTitleOverride="Listado RBD"
      columnOrder={[
        "checkbox",
        "rbd",
        "Nombre",
        "operador",
        "concurso",
        "estado",
        "detalle"
      ]}
      filtersConfig={includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN]) ? [
        { item: "operador", name: "Operador" },
        { item: "concurso", name: "Convocatoria" },
        { item: "estado", name: "Estado" }
      ] : [
        { item: "concurso", name: "Convocatoria" },
        { item: "estado", name: "Estado" }
      ]}
    />

    </PageBody>
  );
}
